import * as React from 'react'

import {
  Field,
  FieldTitle,
} from '~/client/src/shared/components/shadcn-ui/field'
import { cn } from '~/client/src/shared/utils/cn'

interface ISectionProps {
  title: string
  children: React.ReactNode
}

/** Figma "Form Section" — a section title above a bordered card of fields. */
export const SettingsFormSection: React.FC<ISectionProps> = ({
  title,
  children,
}) => (
  <section className="tw:flex tw:w-full tw:flex-col tw:gap-2">
    <h3 className="tw:m-0 tw:text-app-section-title tw:text-foreground">
      {title}
    </h3>
    <div className="tw:flex tw:w-full tw:flex-col tw:items-start tw:gap-4 tw:rounded-xl tw:border tw:border-input-soft tw:p-5">
      {children}
    </div>
  </section>
)

interface IFieldProps {
  /** Leading column — an icon + caption, or a checkbox/radio and its label. */
  label: React.ReactNode
  /**
   * Caption colour. Muted by default, which is what an ordinary row wants; the
   * schedule passes `false` to bring the selected mode and the worked days
   * forward.
   */
  isMuted?: boolean
  children?: React.ReactNode
}

/**
 * Figma "StruxField" — a caption column capped at 200px beside a control that
 * takes the rest of the row, so every control in the card starts at the same x.
 */
export const SettingsField: React.FC<IFieldProps> = ({
  label,
  isMuted = true,
  children,
}) => (
  <Field orientation="columns">
    {/* FieldTitle, not FieldLabel: the value is a picker or a select, and the
        checkbox/radio rows bring their own <label>. */}
    <FieldTitle
      className={cn(
        'tw:w-auto tw:min-w-[120px] tw:max-w-[200px] tw:flex-1 tw:text-app-dense',
        isMuted ? 'tw:text-muted-foreground' : 'tw:text-foreground',
      )}
    >
      {label}
    </FieldTitle>
    {children && <div className="tw:min-w-0 tw:flex-1">{children}</div>}
  </Field>
)
